import Cookies from "js-cookie";

export const getZipFromResponce = (zip) => {
  if (Boolean(Cookies.get("user-zip") !== zip)) {
    Cookies.set("user-zip", zip, { expires: 30 });
  }
};
